/* ============
 * Admin Groups State
 * ============
 *
 * The state of the admin-groups module.
 */

export default {
  all: [],
  pagination: {
    totalCount: 0,
    totalPages: 0,
    currentPage: 1,
    limit: 20,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/admin-groups/state.js